import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import HttpUtility from "../../utilities/HttpUtility";

import AuthModel from "./models/AuthModel";
import jwt_decode from "jwt-decode";

export default class AuthEffect {
  static async requestLogin(username, password, callBackFunction) {
    const endpoint = environment.api.login;
    const response = await HttpUtility.post(endpoint, {
      username: username,
      password: password,
    });

    if (response instanceof HttpErrorResponseModel) {
      return response;
    }
    localStorage.setItem("Auth", JSON.stringify(response.data));

    const token = response.data.access_token;
    const decoded = jwt_decode(token);
    // localstorage set
    localStorage.setItem("roles", JSON.stringify(decoded.realm_access.roles));
    localStorage.setItem("userId", decoded.sub);
    if (response.status === 200) {
      callBackFunction()
    }
    return new AuthModel(response.data);
  }
}
